/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import type { FeePool, FeePoolInterface } from '../FeePool'

const _abi = [
  {
    inputs: [
      {
        internalType: 'contract ERC20',
        name: '_token',
        type: 'address'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'OwnershipTransferred',
    type: 'event'
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_account',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_amount',
        type: 'uint256'
      }
    ],
    name: 'sendProfitERC20',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'token',
    outputs: [
      {
        internalType: 'contract IERC20',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_recipient',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_amount',
        type: 'uint256'
      }
    ],
    name: 'withdraw',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  }
]

const _bytecode =
  '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'

export class FeePool__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0])
    } else {
      super(...args)
    }
  }

  deploy(
    _token: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<FeePool> {
    return super.deploy(_token, overrides || {}) as Promise<FeePool>
  }
  getDeployTransaction(
    _token: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_token, overrides || {})
  }
  attach(address: string): FeePool {
    return super.attach(address) as FeePool
  }
  connect(signer: Signer): FeePool__factory {
    return super.connect(signer) as FeePool__factory
  }
  static readonly bytecode = _bytecode
  static readonly abi = _abi
  static createInterface(): FeePoolInterface {
    return new utils.Interface(_abi) as FeePoolInterface
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): FeePool {
    return new Contract(address, _abi, signerOrProvider) as FeePool
  }
}
